module.exports = __webpack_public_path__ + "static/media/selected_shipyard_marker.3068fa42.svg";